import { IComponentController } from 'angular';

export class LoadingSpinnerController implements IComponentController {
}
